import Content from "./content";
import { firmStats } from "~/util/review";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";
import { IOfferResultItem } from "~/interfaces";
import { createCommercialCollaboration } from "~/ui/commercialCollaboration";

interface IOfferItem {
	elm: HTMLDivElement;
	// TODO: tohle by melo mit typ podle toho, jak to vypada v datech detailu, ale to jeste neni otypovane a jen tak nebude, tak je to tady
	data: IOfferResultItem;
}

/**
 * @class Nabídky, akce, události firem
 */
export default class Offers extends Content {
	_items: Array<IOfferItem>;

	constructor(data: any, options: any) {
		super(data, options);

		this._build2();
	}

	_build2() {
		this._items = [];
		this._dom.container.classList.add("content-offers");
		if ((!this._data.offers || !this._data.offers.result || !this._data.offers.result.length)
			&& (!this._data.actualOffers || !this._data.actualOffers.length || !this._data.actualOffers[0].items || !this._data.actualOffers[0].items.length)) {
			return;
		}

		const header = node("div", { className: "contentoffers__header" });

		header.append(node("h3", { innerHTML: _("detail.content.offers.title", Mapy.Util.escapeHTML(this._data.title)) }), createCommercialCollaboration({ align: "right" }));
		this._dom.container.appendChild(header);

		if (!this._data.offers || !this._data.offers.result || !this._data.offers.result.length) {
			return;
		}

		Mapy.getComponent("logger").log("view", {
			number: this._data.offers && this._data.offers.result ? this._data.offers.result.length : 0,
			origin: "firmy-vizitky-akce",
		});

		for (let index = 0; index < this._data.offers.result.length; index++) {
			this._items.push({
				elm: this._buildItem(this._data.offers.result[index]),
				data: this._data.offers.result[index],
			});
		}

		this._dom.container.addEventListener("click", this);
	}

	destroy() {
		super.destroy();
	}

	handleEvent(event: MouseEvent) {
		let data: IOfferResultItem = null;
		const leaflet: { [key: string]: number } = {};

		for (let index = 0; index < this._items.length; index++) {
			if (this._items[index].elm.contains(event.target as Node)) {
				data = this._items[index].data;
			}
		}

		if (data) {
			leaflet[data.type] = data.id;
			firmStats("firmy-vizitka-akce", this._data, {
				placeId: 1,
				typeId: 4,
				leafletsShown: leaflet,
				id: this._data.id,
				name: this._data.title,
				source: "firm",
			});
		}
	}

	_buildItem(data: IOfferResultItem) {
		// logujeme zobrazeni kazde zvlast
		const leaflet: { [key: string]: number } = {};

		leaflet[data.type] = data.id;
		firmStats("leafletsImpress", this._data, {
			placeId: 1,
			typeId: 4,
			leafletsShown: leaflet,
		});

		const div = node("div", { className: "item" });
		const link = data.url ? `<a href="${data.url.replace(/"/gu, "&quot;")}" rel="noopener" target="_blank" data-log-ignore="1">%s</a>` : "%s";

		// klikaci, pokud je URL
		div.insertAdjacentHTML("beforeend", link.replace("%s", ""));

		// ikona
		div.appendChild(icon(data.type));

		// textovy obsah
		const content = node("div", { className: "text" });

		// nadpis
		content.insertAdjacentHTML("beforeend", `<h4>${link.replace("%s", Mapy.Util.escapeHTML(data.title))}</h4>`);
		// popis
		if (data.text && !(data.date_from || data.date_to)) {
			content.insertAdjacentHTML("beforeend", `<p>${link.replace("%s", Mapy.Util.escapeHTML(data.text))}</p>`);
		}
		// datum
		if (data.date_from || data.date_to) {
			const format = "d. m. yyyy";
			const dfrom = data.date_from ? Mapy.Util.dateFormat(new Date(data.date_from), format) : null;
			const dto = data.date_to ? Mapy.Util.dateFormat(new Date(data.date_to), format) : null;

			content.insertAdjacentHTML("beforeend", `<p>${link.replace("%s", (dfrom ? dfrom : "") + (dfrom && dto ? " &ndash; " : "") + (dto ? dto : ""))}</p>`);
		}
		div.appendChild(content);

		this._dom.container.appendChild(div);

		return div;
	}
}
